import { render, staticRenderFns } from "./EditMemo.vue?vue&type=template&id=7e12460a&"
import script from "./EditMemo.vue?vue&type=script&lang=js&"
export * from "./EditMemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports